import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export function customAlert(errRes) {
    try {
        const { statusCode, message } = errRes;
        if (statusCode && message)
            notify("error", message);
        else throw errRes
    } catch (error) {
        notify("error", "Something went wrong");
    }
}

export function notify(type, msg) {
    switch (type) {
        case "success": toast.success(msg, {
            theme: "colored"
        }); break;
        case "error": toast.error(msg, {
            theme: "colored"
        }); break;
        default: toast.info(msg, {
            theme: "colored"
        });
    }
}